<template>
<div style="color:white">
  <v-avatar :size="viewWidth<450?80:120">
    <v-img :src="require('@/assets/img/juliazhao.png')"></v-img>
    <div class="juliazhao" style="display:block;position: absolute;bottom:5px;"
         v-bind:style="{'font-size':viewWidth<450?'medium':'x-large'}">Julia Zhao
    </div>
  </v-avatar>
  <p style="font-size:small">DRE #01411270<br/>RE/MAX Elite Realty</p>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "avatar",
    computed: {
      ...mapState({
        viewWidth: state => state.homeStore.viewWidth,
        viewHeight: state => state.homeStore.viewHeight - 60,
      })
    }
  }
</script>

<style scoped>

</style>
